<div class="profile-picture">
  <vc-file-input [(ngModel)]="profilePicture" [makeSquare]="true" [hideRemove]="true"></vc-file-input>
  <div class="select-photo" *ngIf="profilePicture">
    <span class="material-icons">photo_camera</span> Select new photo
  </div>
</div>
